import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

class FiltroVistaRegimentalMagistrado extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Resultado de apreciação: "NÃO JULGADO - Vista Regimental" para o magistrado';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        let retorno = [];
        let vistas = registro.informacoesAdicionais.VistaRegimental;

        if (vistas && vistas.length > 0) {
            retorno = vistas.map((vista) => vista.sigla);
        }

        return retorno;
    }
}

export default FiltroVistaRegimentalMagistrado;
